import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Link } from '@mui/material'
import { styled } from '@mui/material/styles'
import Spinner from '../Spinner'

const StyledLink = styled(Link)(({ theme, disabled }) => ({
    '&:hover': {
        cursor: disabled ? 'default' : 'pointer',
    },
}))

const StyledBox = styled(Box)(
    ({
        theme,
        width,
        height,
        borderRadius,
        bgColor,
        border,
        hoverColor,
        disabled,
        style,
    }) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius,
        width,
        height,
        backgroundColor: bgColor,
        border,
        opacity: disabled && 0.7,
        '&:hover': {
            backgroundColor: hoverColor,
        },
        ...style,
    }),
)

const StyledTypography = styled(Typography)(
    ({ theme, disabled, fontColor, fontSize, fontWeight }) => ({
        color: disabled ? '#b4b4b4' : fontColor,
        fontSize,
        fontWeight,
    }),
)

const ButtonV2 = ({
    fontSize,
    fontColor,
    fontWeight,
    label,
    width,
    height,
    borderRadius,
    bgColor,
    border,
    icon,
    onClick,
    hoverColor,
    loading,
    loadingLabel,
    spinnerColor,
    disabled,
    style,
}) => {
    return (
        <StyledLink
            component="button"
            underline="none"
            onClick={onClick}
            disabled={disabled}
        >
            <StyledBox
                width={width}
                height={height}
                borderRadius={borderRadius}
                bgColor={bgColor}
                border={border}
                hoverColor={hoverColor}
                disabled={disabled}
                style={style}
            >
                {loading && (
                    <>
                        <Spinner
                            size={0.8}
                            color={spinnerColor ? spinnerColor : '#fff'}
                        />

                        {loadingLabel && (
                            <StyledTypography
                                disabled={disabled}
                                fontColor={spinnerColor}
                                fontSize={fontSize}
                                fontWeight={fontWeight}
                                sx={{ paddingLeft: '0.6rem' }}
                            >
                                {loadingLabel}
                            </StyledTypography>
                        )}
                    </>
                )}

                {icon}

                {!loading && (
                    <StyledTypography
                        disabled={disabled}
                        fontColor={fontColor}
                        fontSize={fontSize}
                        fontWeight={fontWeight}
                    >
                        {label}
                    </StyledTypography>
                )}
            </StyledBox>
        </StyledLink>
    )
}

ButtonV2.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    borderRadius: PropTypes.string,
    bgColor: PropTypes.string,
    border: PropTypes.string,
    fontSize: PropTypes.string,
    fontColor: PropTypes.string,
    fontWeight: PropTypes.string,
    hoverColor: PropTypes.string,
    onClick: PropTypes.func,
    //icon: PropTypes.node,
    // list: PropTypes.array.isRequired,
}

ButtonV2.defaultProps = {
    width: '10rem',
    height: '4.8rem',
    borderRadius: '1.65rem',
    bgColor: '#ffffff',
    border: 'none',
    fontSize: '1.2rem',
    fontColor: '#0057A0;',
    fontWeight: 'normal',
}
export default ButtonV2
